import {ActionTypes} from './action-types';
import {processFolders} from '../services/folder';

const cloneFolderTree = folder => {
  if (!folder) {
    return folder;
  }
  return {
    ...folder,
    attributes: Array.isArray(folder.attributes) ? [...folder.attributes] : folder.attributes,
    children: Array.isArray(folder.children)
      ? folder.children.map(child => cloneFolderTree(child))
      : folder.children
  };
};

const cloneFolderList = folders =>
  Array.isArray(folders) ? folders.map(folder => cloneFolderTree(folder)) : folders;

export const backendRequest = () => ({type: ActionTypes.FOLDERS_BE_REQUEST});
export const backendRequestReset = () => ({type: ActionTypes.FOLDERS_BE_REQUEST_RESET});
export const setFolders = folders => ({
  type: ActionTypes.FOLDERS_SET, payload: processFolders(cloneFolderList(folders))
});

export const setFirstSyncImap = firstSyncCompleted => ({
  type: ActionTypes.SET_FIRST_SYNC_IMAP,
  payload: firstSyncCompleted
});

export const updateFolder = folder => {
  folder = processFolders([cloneFolderTree(folder)])[0];
  return ({type: ActionTypes.FOLDERS_UPDATE, payload: folder});
};

export const updateParentFolder = folder => {
  folder = processFolders([cloneFolderTree(folder)])[0];
  return ({type: ActionTypes.FOLDERS_UPDATE_PARENT_ONLY, payload: folder});
};

export const setShowMoveFolderAlert = showMoveFolderAlert => ({
  type: ActionTypes.FOLDERS_SET_SHOW_MOVE_FOLDER_ALERT,
  payload: showMoveFolderAlert
});

export const setIsUpdatedFolder = isUpdatedFolder => ({
  type: ActionTypes.FOLDERS_SET_IS_UPDATED_FOLDER,
  payload: isUpdatedFolder
});

export const setShowFolderList = showFolderList => ({
  type: ActionTypes.FOLDERS_SET_SHOW_FOLDER_LIST, 
  payload: showFolderList
});
